import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatApiError } from "@/lib/format-api-error";
import { useApproveRequest } from "./use-approve-request";

// Sub-bucket 15 — port of /app/admin/mdf/requests/_components/ApproveRequestDialog.tsx.
// Approval commits budget against the allocation and dispatches both a
// MDF_REQUEST_APPROVED notification and a HubSpot Note (both fire-and-forget
// from the service); no receipt upload on approve (legacy parity).

export function ApproveRequestDialog({
  requestId,
  fundId,
  open,
  onOpenChange,
}: {
  requestId: string;
  fundId: string;
  open: boolean;
  onOpenChange: (next: boolean) => void;
}) {
  const approve = useApproveRequest();

  function onConfirm() {
    approve.mutate(
      { id: requestId, fundId },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
        onError: (err) =>
          toast.error(formatApiError(err, "Failed to approve request")),
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">
            Approve request?
          </DialogTitle>
          <DialogDescription>
            Approval commits the budget against the partner&apos;s allocation
            and notifies the partner. You can later mark it as spent once the
            campaign runs.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={approve.isPending}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={approve.isPending}
          >
            {approve.isPending && (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            )}
            Approve
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
